import { render, staticRenderFns } from "./convocationEmpty.vue?vue&type=template&id=1c8fa078&scoped=true"
import script from "./convocationEmpty.vue?vue&type=script&lang=js"
export * from "./convocationEmpty.vue?vue&type=script&lang=js"
import style0 from "./convocationEmpty.vue?vue&type=style&index=0&id=1c8fa078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8fa078",
  null
  
)

export default component.exports